module.exports = __webpack_public_path__ + "static/media/unauthorised-156169_1280.4b03e9af.png";